import React, { useState, useEffect } from 'react';
import { Upload, message, Avatar } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { validateLogo } from '../../utils/validation';
import { getInitials } from '../../utils/helpers';

const LogoUploader = ({ value, onChange, partnerName, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (typeof value === 'string' && value) {
      setImageUrl(value);
    }
  }, [value]);

  const beforeUpload = (file) => {
    const validation = validateLogo(file);

    if (!validation.isValid) {
      validation.errors.forEach((error) => message.error(error));
      return Upload.LIST_IGNORE;
    }

    // Read file as data URL for preview
    setLoading(true);
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setImageUrl(reader.result);
      setLoading(false);
    });
    reader.readAsDataURL(file);

    // Pass the file to the form
    onChange?.(file);

    return false; // Prevent auto upload
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <div className="logo-uploader">
      <Upload
        name="logo"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={disabled}
        accept="image/jpeg,image/png,image/svg+xml"
      >
        {imageUrl ? (
          <img src={imageUrl} alt="logo" style={{ width: '100%', objectFit: 'contain' }} />
        ) : partnerName ? (
          <Avatar size={64} style={{ backgroundColor: '#1890ff' }}>
            {getInitials(partnerName)}
          </Avatar>
        ) : (
          uploadButton
        )}
      </Upload>
      <style>{`
        .logo-uploader .ant-upload.ant-upload-select-picture-card {
          width: 120px;
          height: 120px;
        }
        .logo-uploader .ant-upload-select-picture-card {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </div>
  );
};

export default LogoUploader;
